import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import MainPage from '../views/MainPage.vue';

const Blog = () => import('../views/Blog.vue');
const Post = () => import('../views/Post.vue');
const PaymentInfo = () => import('../views/PaymentInfo.vue');
const CounterParties = () => import('../views/counterparties/CounterParties.vue');
const Profile = () => import('../views/Profile.vue');
const ProfileInfo = () => import('../views/profile/ProfileInfo.vue');
const Subscription = () => import('../views/profile/Subscription.vue');
const Friends = () => import('../views/profile/Friends.vue');
const Basket = () => import('../views/profile/Basket.vue');
const Favorites = () => import('../views/profile/Favorites.vue');
const Orders = () => import('../views/profile/Orders.vue');
const Products = () => import('../views/profile/Products.vue');
const AddProduct = () => import('../views/profile/AddProduct.vue');
const Support = () => import('../views/profile/Support.vue');
const Reviews = () => import('../views/profile/Reviews.vue');
const AddCompany = () => import('../views/profile/AddCompany.vue');
const Marketplace = () => import('../views/Marketplace.vue');
const MarketplaceItem = () => import('../views/marketplace/Item.vue');
const Company = () => import('../views/marketplace/Company.vue');
const Messages = () => import('@/views/profile/Messages.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'MainPage',
    component: MainPage,
  },
  {
    path: '/reset-password/:uid/:token',
    name: 'ResetPassword',
    component: MainPage,
    beforeEnter: (to, _from, next) => {
      const { uid, token } = to.params;
      next({ name: 'MainPage', query: { uid: uid, token: token } });
    },
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
  },
  {
    path: '/blog/:id',
    name: 'Post',
    component: Post,
  },
  {
    path: '/payment-info',
    name: 'PaymentInfo',
    component: PaymentInfo,
  },
  {
    path: '/counter-parties/:id',
    name: 'CounterParties',
    component: CounterParties,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    children: [
      {
        path: 'info',
        name: 'ProfileInfo',
        component: ProfileInfo,
      },
      {
        path: 'add-company',
        name: 'AddCompany',
        component: AddCompany,
      },
      {
        path: 'subscription',
        name: 'Subscription',
        component: Subscription,
      },
      {
        path: 'friends',
        name: 'Friends',
        component: Friends,
      },
      {
        path: 'basket',
        name: 'Basket',
        component: Basket,
      },
      {
        path: 'favorites',
        name: 'Favorites',
        component: Favorites,
      },
      {
        path: 'orders',
        name: 'Orders',
        component: Orders,
      },
      {
        path: 'products',
        name: 'Products',
        component: Products,
      },
      {
        path: 'products/add',
        name: 'AddProduct',
        component: AddProduct,
      },
      {
        path: 'products/edit/:id',
        name: 'EditProduct',
        component: AddProduct,
      },
      {
        path: 'messages',
        name: 'Messages',
        component: Messages,
      },
      {
        path: 'reviews',
        name: 'Reviews',
        component: Reviews,
      },
      {
        path: 'support',
        name: 'Support',
        component: Support,
      },
    ],
  },
  {
    path: '/marketplace',
    name: 'Marketplace',
    component: Marketplace,
  },
  {
    path: '/marketplace/:id',
    name: 'MarketplaceItem',
    component: MarketplaceItem,
  },
  {
    path: '/company/:id',
    name: 'Company',
    component: Company,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    // Если сохранена позиция
    if (savedPosition) {
      return savedPosition;
    }

    // Если в маршруте указан хэш
    if (to.hash) {
      const element = document.querySelector(to.hash);

      if (element) {
        // Прокручиваем к элементу
        return {
          el: to.hash,
          behavior: 'smooth',
        };
      } else {
        return { top: 0 };
      }
    }

    return { top: 0 };
  },
});

export default router;
